import PropTypes from "prop-types";
import Text from "shared/components/data-display/mui/Text";
import moment from "moment";
import { useStylesForText } from "shared/styles/makeStyles";
import { AbsenceWrapper, DateWrapper, DayWrapper, ReasonWrapper } from "./TimeOffOverlay.styles";

const medium_sizeMediumStyle = {
    fontFamily: globalThis.config.fonts.families.medium,
    fontSize: globalThis.config.fonts.sizes.medium,
};

const medium_sizeSmediumStyle = {
    fontFamily: globalThis.config.fonts.families.medium,
    fontSize: globalThis.config.fonts.sizes.smedium,
};

const regular_sizeSmediumStyle = {
    fontFamily: globalThis.config.fonts.families.regular,
    fontSize: globalThis.config.fonts.sizes.smedium,
};

const TimeOffOverlay = (props) => {
    const { week, timeOffData, employeeData, allocatedHours, availableHours } =
        props;

    const classesText = useStylesForText();

    const timeOffDescription = week.map((d) => (
        <div key={d}>
            <DateWrapper>
                <Text
                    style={regular_sizeSmediumStyle}
                    className={classesText.white}
                >
                    {moment(d).format("MMM") + " " + moment(d).format("D")}
                </Text>
            </DateWrapper>
            <DayWrapper>
                <Text
                    style={medium_sizeSmediumStyle}
                    className={classesText.white}
                >
                    {moment(d).format("ddd")}
                </Text>
            </DayWrapper>
            <ReasonWrapper>
                <Text
                    style={regular_sizeSmediumStyle}
                    className={classesText.white}
                >
                    {timeOffData?.find(
                        (t) => moment(t.date).format("YYYY-MM-DD") === d
                    )?.reason ?? <span>&mdash;</span>}
                </Text>
            </ReasonWrapper>
        </div>
    ));

    return (
        <>
            <Text
                style={medium_sizeMediumStyle}
                className={classesText.white}
            >
                {" "}
                {employeeData.name}
            </Text>
            <Text
                style={medium_sizeSmediumStyle}
                className={classesText.white}
            >
                {" "}
                Hrs Allocated: {allocatedHours} |
                <span
                    style={regular_sizeSmediumStyle}
                    className={classesText.white}
                >
                    {" "}
                    Hrs Available: {availableHours}{" "}
                </span>
            </Text>

            <AbsenceWrapper>{timeOffDescription}</AbsenceWrapper>
        </>
    );
};

TimeOffOverlay.propTypes = {
    week: PropTypes.array.isRequired,
    timeOffData: PropTypes.array,
    employeeData: PropTypes.shape({
        name: PropTypes.string,
    }).isRequired,
    allocatedHours: PropTypes.number,
    availableHours: PropTypes.number,
};

export default TimeOffOverlay;
